import appGlobalScript from '/Users/lucascarvalho/Sydle/sydle-ui-blog/blog/packages/sydle-ui-blog/src/global/app.ts';
export const globalScripts = appGlobalScript;
